import Slider from 'rc-slider';
import React, { Component } from 'react';
import { Button, Col, Modal, Row, Table, Tooltip, OverlayTrigger } from 'react-bootstrap';
import { IconContext } from 'react-icons';
import { MdContentCut } from 'react-icons/md';
import {
  TbArrowAutofitLeft,
  TbArrowAutofitRight,
  TbArrowBarToLeft,
  TbArrowBarToRight,
  TbArrowNarrowLeft,
  TbBracketsContainEnd,
  TbBracketsContainStart,
  TbCaretRightFilled,
  TbChevronDown,
  TbDeviceFloppy,
  TbExternalLink,
  TbHelp,
  TbPlayerPauseFilled,
  TbPlayerPlayFilled,
  TbVolume,
  TbVolumeOff,
  TbCaretLeftFilled
} from 'react-icons/tb';
import ReactLoading from 'react-loading';
import uuidv4 from 'uuid/v4';
import 'shaka-player/dist/controls.css';
import { createAlert, createAlertWithCustomUI } from '../../util/alert';
import * as Api from '../../util/api';
import CustomPlayer from '../Player/CustomPlayer';
import PlayerPreview from '../PlayerPreview/PlayerPreview';
import ClipAlert from '../ClipAlert/ClipAlert';
import faq from './faq.conf.json';

import 'rc-slider/assets/index.css';
import '../../style/common.scss';
import './ModalEditClip.scss';
import { formatTimecode } from '../../util/video';

const Range = Slider.Range;

const frameSize = 1 / 24;

class ModalEditClip extends Component {
  constructor(props) {
    super(props);
    this.state = {
      media: null,
      drm: null,
      startTime: 0,
      currentTime: 0,
      endTime: 0,
      durationSlice: 0,
      slices: [],
      sliceSelected: {},
      icaId: null,
      tyrisToken: null,
      codeToken: null,
      accordionExpanded: false,
      muted: true,
      isPlaying: true,
      volume: 1,
    };
    this.endTimeSet = false;
    this.startTimeSet = false;

    this.calculateSlice = this.calculateSlice.bind(this);
    this.addSlice = this.addSlice.bind(this);
    this.insertSlices = this.insertSlices.bind(this);
    this.listenerFunction = this.listenerFunction.bind(this);
    this.refPlayer = this.refPlayer.bind(this);
    this.isDragging = false;
  }

  componentDidMount() {
    this.endTimeSet = false;
    this.startTimeSet = false;
  }

  componentWillMount() {
    window.addEventListener('message', this.listenerFunction, false);
  }

  componentWillUnmount() {
    window.removeEventListener('message', this.listenerFunction, false);
  }

  listenerFunction = async (event) => {
    if (this.processing) return;
    this.processing = true;
    if (
      [
        event.data.icaId,
        event.data.tyrisToken,
        event.data.codeToken,
        event.data.expire,
        event.data.countryAllow,
      ].every((element) => element)
    ) {
      const { media } = await this.getMedia(
        event.data.icaId,
        event.data.codeToken,
        event.data.expire,
        event.data.countryAllow,
      );

      let drm = null;
      if (media && media.mpd) {
        drm = await this.getDrm(event.data.codeToken, media.id);
      }

      const { slices } = await this.getSlices(
        event.data.icaId,
        event.data.tyrisToken,
      );
      this.setState({
        icaId: event.data.icaId,
        tyrisToken: event.data.tyrisToken,
        codeToken: event.data.codeToken,
        media: media,
        drm: drm
          ? {
            servers: {
              'com.widevine.alpha': drm.widevineLicense,
              'com.microsoft.playready': drm.playreadyLicense,
              'com.apple.fps': drm.fairplayLicense,
            },
            authToken: drm.nvauthorizations,
            advanced: {
              'com.apple.fps': {
                serverCertificateUri: drm.fairplayCertificate,
              },
            },
          }
          : null,
        slices: slices,
        endTime: media.duration,
        durationSlice: media.duration,
        expire: event.data.expire,
        countryAllow: event.data.countryAllow,
      });
    }
    this.processing = false;
  };

  goBack = () => {
    window.parent.postMessage({ goBack: true }, '*');
  };

  toggleAccordion = () => {
    this.setState((prevState) => ({
      accordionExpanded: !prevState.accordionExpanded,
    }));
  };

  navigateToClips = () => {
    window.parent.postMessage({ navigateToClips: true }, '*');
  };

  refPlayer(player) {
    this.player = player;
    if (this.player) {
      this.player.setVolume(this.state.volume);
      this.player.setMuted(this.state.muted);
    }
  }

  async getMedia(icaId, codeToken, expire, countryAllow) {
    try {
      const media = (
        await Api.getMediaByFilters(codeToken, icaId, expire, countryAllow)
      )[0];

      return {
        media:
          media !== null && media !== undefined
            ? media
            : { mpd: '', title: 'Media not Found' },
      };
    } catch (error) {
      const status = error && error.status;
      const e = status ? await error.json() : error;
      createAlert('Error', `${e.msg || e}`, [{ label: 'OK' }]);
    }
  }

  async getDrm(codeToken, mediaId) {
    try {
      return await Api.getDrm(codeToken, mediaId);
    } catch (error) {
      const status = error && error.status;
      const e = status ? await error.json() : error;
      createAlert('Error', `${e.msg || e}`, [{ label: 'OK' }]);
      return null;
    }
  }

  async getSlices(icaId, tyrisToken) {
    try {
      const slices = await Api.getSlices(tyrisToken, icaId);
      return { slices: slices.clips ? slices.clips : [] };
    } catch (error) {
      const status = error && error.status;
      const e = status ? await error.json() : error;
      createAlert('Error', `${e.msg || e}`, [{ label: 'OK' }]);
    }
  }

  async insertSlices(navigate = false) {
    try {
      await Api.insertSlices(
        this.state.tyrisToken,
        this.state.icaId,
        this.state.slices,
      );
      if (navigate) {
        this.navigateToClips();
      } else {
        createAlertWithCustomUI(InsertSlicesModal);
      }
      // createAlert('Test', null,  [{label: 'aceptar'}]);
    } catch (error) {
      const status = error && error.status;
      const e = status ? await error.json() : error;
      let errorMessage =
        'Se ha producido un error en el guardado de los clips.';
      switch (e.error) {
        case '400.12':
          errorMessage = 'Se ha alcanzado el número máximo de clips por vídeo.';
          break;
        case '400.14':
          errorMessage =
            'Se ha alcanzado el procentaje máximo de vídeo a recortar (70%).';
          break;
        default:
      }
      createAlert('Error', errorMessage, [{ label: 'Aceptar' }]);
    }
  }

  async calculateSlice(values) {
    const { startTime, media } = this.state;

    if (values[0] >= 0 && values[1] <= media.duration) {
      this.setState(
        {
          startTime: values[0],
          endTime: values[1],
          durationSlice: values[1] - values[0],
        },
        () => {
          values[0] !== startTime
            ? (this.startTimeSet = true)
            : (this.endTimeSet = true);
        },
      );
    }
  }

  addSlice() {
    const { startTime, endTime, durationSlice } = this.state;
    const slices = JSON.parse(JSON.stringify(this.state.slices));

    slices.push({
      id: uuidv4(),
      start: startTime,
      end: endTime,
      duration: durationSlice,
    });
    this.setState({
      slices,
      startTime: 0,
      endTime: this.state.media.duration,
      durationSlice: this.state.media.duration,
    });
  }

  removeSlice(index) {
    const slices = JSON.parse(JSON.stringify(this.state.slices));
    slices.splice(index, 1);
    this.setState({ slices });
  }

  getTotalDurationPercentage = () => {
    const { slices, durationSlice, media } = this.state;
    const totalDuration = slices.reduce((acc, slice) => acc + slice.duration, 0);
    return Math.round(((totalDuration + durationSlice) / media.duration) * 1000) / 10; // multiply by 1000 and divide by 10 to avoid rounding issues
  }

  togglePlay = () => {
    if (!this.player) return;
    const isPlaying = !this.state.isPlaying;
    if (isPlaying) {
      this.player.play();
    } else {
      this.player.pause();
    }
    this.setState({ isPlaying });
  };

  toggleMute = () => {
    const muted = !this.state.muted;
    let volume = this.state.volume;
    if (!muted && volume === 0) {
      volume = 1;
    }
    if (this.player) {
      this.player.setMuted(muted);
      this.player.setVolume(volume);
    }
    this.setState({ muted, volume });
  };

  handleVolumeChange = (value) => {
    const muted = value === 0;
    if (this.player) {
      this.player.volume = value;
      this.player.muted = muted;
    }
    this.setState({
      volume: value,
      muted,
    });
  };

  handleSeek = (e) => {
    const newTime = parseFloat(e.target.value);
    if (this.player) {
      this.player.seekTo(newTime);
    }
    this.setState({ currentTime: newTime });
  };

  handleSeekWheel = (e) => {
    const { currentTime, media } = this.state;
    if (!media || !media.duration) return;
    const step = e.shiftKey ? 1 : 0.2;
    const delta = e.deltaY < 0 ? step : -step;
    const newTime = Math.min(Math.max(0, currentTime + delta), media.duration);
    if (this.player) {
      this.player.seekTo(newTime);
    }
    this.setState({ currentTime: newTime });
  };

  handleMouseDown = (e) => {
    e.preventDefault();
    e.stopPropagation();
    const { media } = this.state;
    if (!media || !media.duration) return;

    this.isDragging = true;
    const rangeElement = e.currentTarget.closest('.controls__range');
    if (!rangeElement) return;

    const updateTimeFromEvent = (moveEvent) => {
      const rect = rangeElement.getBoundingClientRect();
      const offsetX = Math.max(0, Math.min(rect.width, moveEvent.clientX - rect.left));
      const newTime = (offsetX / rect.width) * media.duration;
      if (this.player) {
        this.player.seekTo(newTime);
      }
      this.setState({ currentTime: newTime });
    };

    const handleMouseMove = (moveEvent) => {
      updateTimeFromEvent(moveEvent);
    };

    const handleMouseUp = () => {
      this.isDragging = false;
      window.removeEventListener('mousemove', handleMouseMove);
      window.removeEventListener('mouseup', handleMouseUp);
    };

    window.addEventListener('mousemove', handleMouseMove);
    window.addEventListener('mouseup', handleMouseUp);
  };

  renderTooltip = (text) => (props) => (
    <Tooltip id={`tooltip-${text}`} {...props}>
      {text}
    </Tooltip>
  );

  seekTo(time) {
    if (this.player) {
      this.player.seekTo(time);
    }
    this.setState({ currentTime: time });
  }

  stepForward = () => {
    if (!this.player?.stepForward) return;
    this.player.stepForward();
    this.setState({ isPlaying: false });
  };

  stepBack = () => {
    if (!this.player?.stepBack) return;
    this.player.stepBack();
    this.setState({ isPlaying: false });
  };


  render() {
    const {
      media,
      drm,
      startTime,
      endTime,
      currentTime,
      durationSlice,
      slices,
      sliceSelected,
      icaId,
      codeToken,
      tyrisToken,
    } = this.state;

    const handleProgress = (event) => {
      if (!this.isDragging) {
        this.setState({ currentTime: event });
      }
    };

    return (
      <Modal.Dialog id="modal-edit-clip">
        {icaId === null && codeToken === null && tyrisToken === null ? (
          <div className="loading">
            <Row>
              <ReactLoading
                type={'spokes'}
                color={'var(--primary-color)'}
                height={'20%'}
                width={'20%'}
                className="medialibrary-spinner"
              />
            </Row>
            <Row>
              <h3>CARGANDO...</h3>
            </Row>
          </div>
        ) : (
          <div className="tooling">
            <div className="title-container">
              <div className="arrow-back-container">
                <button className="arrow-back" onClick={this.goBack}>
                  <TbArrowNarrowLeft size={25} />
                </button>
              </div>
              <h1 className="title">Editar recortes: {media.title}</h1>
              <div
                className={`accordion accordion-container ${this.state.accordionExpanded ? 'show' : ''}`}
              >
                <button
                  className="accordion-header"
                  onClick={this.toggleAccordion}
                >
                  <TbHelp className="button-icon" size={30} />
                  Ayuda sobre los recortes
                  <TbChevronDown className="accordion-header__toggle" />
                </button>
                <div className="accordion-body-container">
                  <dl className="accordion-body">
                    {faq.map((element, index) => (
                      <React.Fragment key={index}>
                        <dt
                          dangerouslySetInnerHTML={{ __html: element.title }}
                          key={index + 1}
                        ></dt>
                        <dd
                          dangerouslySetInnerHTML={{
                            __html: element.description,
                          }}
                          key={index + 1 + '-d'}
                        ></dd>
                      </React.Fragment>
                    ))}
                  </dl>
                </div>
              </div>
            </div>
            <div className="crop-tool">
              <Row className="player">
                {media.bitrates?.length > 0 ? (
                  <Col className="iframe">
                    <CustomPlayer
                      ref={this.refPlayer}
                      id="player"
                      url={media.mpd ?? media.m3u8}
                      playing={this.state.isPlaying}
                      muted={this.state.muted}
                      volume={this.state.volume}
                      controls={false}
                      loop
                      drmConfig={drm}
                      onProgress={handleProgress}
                      style={{ width: '100%', height: 'auto', minHeight: '20vh' }}
                    />
                    <div className="controls">
                      <div className='controls__range'>
                        <Range
                          className="player-slicer"
                          min={0}
                          max={media.duration}
                          value={[startTime, endTime]}
                          defaultValue={[startTime, endTime]}
                          onChange={this.calculateSlice}
                          marks={{
                            0: formatTimecode(0),
                            [this.state.startTime]: formatTimecode(this.state.startTime),
                            [this.state.endTime]: formatTimecode(this.state.endTime),
                            [media.duration]: formatTimecode(media.duration),
                          }}
                          railStyle={{
                            height: '20px',
                            backgroundColor: '#e9e9e963',
                          }}
                          style={{
                            height: '20px',
                            boxSizing: 'content-box',
                          }}
                          dots={false}
                          allowCross={false}
                        />
                        <div className='controls__range__current-time' style={{
                          left: `${currentTime / media.duration * 100}%`
                        }}>
                          <span
                            className="handle"
                            onMouseDown={this.handleMouseDown}
                            onWheel={this.handleSeekWheel}
                          >
                            {formatTimecode(currentTime)}
                          </span>
                        </div>
                        <input
                          type="range"
                          className="controls__range__seeker"
                          min={0}
                          max={media.duration}
                          step={0.1}
                          value={currentTime}
                          onChange={this.handleSeek}
                          onMouseDown={() => { this.isDragging = true; }}
                          onMouseUp={() => { this.isDragging = false; }}
                          onTouchStart={() => { this.isDragging = true; }}
                          onTouchEnd={() => { this.isDragging = false; }}
                          onWheel={this.handleSeekWheel}
                        />
                      </div>
                      <Row className='controls__actions'>
                        <div className='controls__actions__brackets'>
                          <OverlayTrigger overlay={this.renderTooltip('Establecer inicio')}>
                            <Button className='btn-grey' onClick={() => this.calculateSlice([currentTime, endTime])}><TbBracketsContainStart /></Button>
                          </OverlayTrigger>
                          <OverlayTrigger overlay={this.renderTooltip('Retroceder un frame')}>
                            <Button className='btn-grey' onClick={() => this.stepBack()}><TbArrowAutofitLeft /></Button>
                          </OverlayTrigger>
                          <OverlayTrigger overlay={this.renderTooltip('Ir al inicio del recorte')}>
                            <Button className='btn-grey' onClick={() => this.seekTo(startTime)}><TbArrowBarToLeft /></Button>
                          </OverlayTrigger>
                          <OverlayTrigger overlay={this.renderTooltip(this.state.isPlaying ? 'Pausar' : 'Reproducir')}>
                            <Button className='btn-grey' onClick={() => this.togglePlay()}>{this.state.isPlaying ? <TbPlayerPauseFilled /> : <TbPlayerPlayFilled />}</Button>
                          </OverlayTrigger>
                          <OverlayTrigger overlay={this.renderTooltip('Ir al final del recorte')}>
                            <Button className='btn-grey' onClick={() => this.seekTo(endTime)}><TbArrowBarToRight /></Button>
                          </OverlayTrigger>
                          <OverlayTrigger overlay={this.renderTooltip('Avanzar un frame')}>
                            <Button className='btn-grey' onClick={() => this.stepForward()}><TbArrowAutofitRight /></Button>
                          </OverlayTrigger>
                          <OverlayTrigger overlay={this.renderTooltip('Establecer final')}>
                            <Button className='btn-grey' onClick={() => this.calculateSlice([startTime, currentTime])}><TbBracketsContainEnd /></Button>
                          </OverlayTrigger>
                        </div>
                        <div className='controls__actions__volume'>
                          <OverlayTrigger overlay={this.renderTooltip(this.state.muted ? 'Activar sonido' : 'Silenciar')}>
                            <Button className='btn-grey' onClick={() => this.toggleMute()}>{this.state.muted ? <TbVolumeOff /> : <TbVolume />}</Button>
                          </OverlayTrigger>
                          <Slider
                            className="volume-slider"
                            min={0}
                            max={1}
                            step={0.05}
                            value={this.state.muted ? 0 : this.state.volume}
                            onChange={this.handleVolumeChange}
                          />
                        </div>
                      </Row>
                    </div>
                  </Col>
                ) : (
                  <Col className="no-encoded">
                    <h5>NO ENCODED YET!</h5>
                  </Col>
                )}
              </Row>
              <Row className="clip-info">
                <Col className="clip-col start">
                  <Row className="change-time">
                    <div
                      className="step-btn step-btn--prev"
                      onClick={() =>
                        this.calculateSlice([startTime - frameSize, endTime])
                      }
                    >
                      <TbCaretLeftFilled />
                      <span>
                        1f
                      </span>
                    </div>
                    <div
                      className="step-btn step-btn--prev"
                      onClick={() =>
                        this.calculateSlice([startTime - 1, endTime])
                      }
                    >
                      <TbCaretLeftFilled />
                      <span>
                        1"
                      </span>
                    </div>
                    {formatTimecode(startTime)}
                    <div
                      className="step-btn step-btn--next"
                      onClick={() =>
                        this.calculateSlice([startTime + 1, endTime])
                      }
                    >
                      <span>
                        1"
                      </span>
                      <TbCaretRightFilled />
                    </div>
                    <div
                      className="step-btn step-btn--next"
                      onClick={() =>
                        this.calculateSlice([startTime + frameSize, endTime])
                      }
                    >
                      <span>
                        1f
                      </span>
                      <TbCaretRightFilled />
                    </div>
                  </Row>
                  <Row
                    className="thumbnail"
                    style={{
                      width: '300px',
                      aspectRatio: '16/9',
                      overflow: 'hidden',
                    }}
                  >
                    <div
                      id="player-set-in"
                      style={{
                        backgroundColor: 'rgb(211, 211, 211, 0.4)',
                        height: '100%',
                        display: 'flex',
                        justifyContent: 'center'
                      }}
                    >
                      {this.startTimeSet && (
                        <CustomPlayer
                          id="player"
                          url={media.mpd ?? media.m3u8}
                          playing={false}
                          controls={false}
                          time={startTime}
                          fixedFrame
                          muted
                          drmConfig={drm}
                          style={{ width: 'auto', height: '100%' }}
                        />
                      )}
                    </div>
                    <p>Seleccionar tiempo</p>
                  </Row>
                </Col>
                <Col className="clip-action clip-cut">
                  <Row style={{ width: '100%' }}>
                    <Button
                      className="cut btn-neutral btn-neutral--fill"
                      disabled={
                        durationSlice <= 0.9 ||
                        durationSlice >= media.duration * 0.75 ||
                        !this.player ||
                        this.state.slices.length >= 5 ||
                        this.getTotalDurationPercentage() >= 75
                      }
                      onClick={this.addSlice}
                    >
                      <MdContentCut />
                      Crear recorte
                    </Button>
                  </Row>
                  <Row>Recortes: <span className='clip-action__limit'>{this.state.slices.length}/5</span> | Duración usada: <span className={`clip-action__limit ${this.getTotalDurationPercentage() >= 75 ? 'clip-action__limit--error' : ''}`}>{this.getTotalDurationPercentage()}%</span> de 75%</Row>
                  {this.state.slices.length >= 5 && (
                    <ClipAlert title='Máximo de recortes alcanzado' message="Elimina un recorte para añadir uno nuevo." />
                  )}
                  {this.getTotalDurationPercentage() >= 75 && (
                    <ClipAlert title='Duración máxima superada' message="Ajusta el inicio o el fin del recorte para no superar el 75% de duración total." />
                  )}
                </Col>
                <Col className="clip-col end">
                  <Row className="change-time">
                    <div
                      className="step-btn step-btn--prev"
                      onClick={() =>
                        this.calculateSlice([startTime, endTime - frameSize])
                      }
                    >
                      <TbCaretLeftFilled />
                      <span>
                        1f
                      </span>
                    </div>
                    <div
                      className="step-btn step-btn--prev"
                      onClick={() =>
                        this.calculateSlice([startTime, endTime - 1])
                      }
                    >
                      <TbCaretLeftFilled />
                      <span>
                        1"
                      </span>
                    </div>
                    {formatTimecode(endTime)}
                    <div
                      className="step-btn step-btn--next"
                      onClick={() =>
                        this.calculateSlice([startTime, endTime + 1])
                      }
                    >
                      <span>
                        1"
                      </span>
                      <TbCaretRightFilled />
                    </div>
                    <div
                      className="step-btn step-btn--next"
                      onClick={() =>
                        this.calculateSlice([startTime, endTime + frameSize])
                      }
                    >
                      <span>
                        1f
                      </span>
                      <TbCaretRightFilled />
                    </div>
                  </Row>
                  <Row
                    className="thumbnail"
                    style={{
                      width: '300px',
                      aspectRatio: '16/9',
                      overflow: 'hidden',
                    }}
                  >
                    <div
                      id="player-set-in"
                      style={{
                        backgroundColor: 'rgb(211, 211, 211, 0.4)',
                        height: '100%',
                        display: 'flex',
                        justifyContent: 'center',
                      }}
                    >
                      {this.endTimeSet && (
                        <CustomPlayer
                          id="player"
                          url={media.mpd ?? media.m3u8}
                          playing={false}
                          controls={false}
                          time={endTime}
                          muted
                          fixedFrame
                          drmConfig={drm}
                          style={{ width: 'auto', height: '100%' }}
                        />
                      )}
                    </div>
                    <p>Select Time</p>
                  </Row>
                </Col>
              </Row>
            </div>
            <div className="clips-tool">
              {slices.length > 0 && (
                <>
                  <Table as="row" className="clip-list">
                    <thead>
                      <tr>
                        <th>#</th>
                        <th>Inicio</th>
                        <th>Final</th>
                        <th>Duración</th>
                        <th>Porcentaje</th>
                        <th>
                          Previsualización
                        </th>
                        <th></th>
                      </tr>
                    </thead>
                    <tbody>
                      {slices.map((slice, i) => (
                        <tr
                          key={i}
                          onClick={() =>
                            this.setState({ sliceSelected: slice })
                          }
                        >
                          <td>Recorte {i + 1}</td>
                          <td>{formatTimecode(slice.start)}</td>
                          <td>{formatTimecode(slice.end)}</td>
                          <td>
                            {formatTimecode((slice.end - slice.start))}
                          </td>
                          <td>{~~(((slice.end - slice.start) / media.duration) * 1000) / 10}%</td>
                          <td className="preview">
                            <PlayerPreview
                              url={media.mpd ?? media.m3u8}
                              drm={drm}
                              slice={slice}
                              sliceSelected={sliceSelected}
                            />
                          </td>
                          <td>
                            <Button
                              className="btn btn-remove btn-sm"
                              onClick={() => this.removeSlice(i)}
                            >
                              &times;
                            </Button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                </>
              )}
            </div>
            <div className="actions">
              <Button
                disabled={slices.length <= 0}
                className="btn-primary--fill btn-save btn-center"
                onClick={() => this.insertSlices(false)}
              >
                <TbDeviceFloppy className="button-icon" size={25} />
                Guardar
              </Button>
              <Button
                disabled={slices.length <= 0}
                className="btn-save btn-center"
                onClick={() => this.insertSlices(true)}
              >
                <TbDeviceFloppy className="button-icon" size={25} />
                Guardar e ir a mis recortes
              </Button>
            </div>
          </div>
        )}
      </Modal.Dialog>
    );
  }
}

function InsertSlicesModal({ onClose }) {
  const navigateToClips = () => {
    window.parent.postMessage({ navigateToClips: true }, '*');
  };

  return (
    <IconContext.Provider value={{ size: 25 }}>
      <div className="react-confirm-alert-body">
        <h1>Recorte guardado</h1>
        El proceso de guardado del recorte se ha realizado con éxito
        <div className="react-confirm-alert-button-group">
          <button onClick={onClose} className="white">
            <MdContentCut className="button-icon" color="black" />
            Seguir recortando
          </button>
          <button onClick={navigateToClips}>
            <TbExternalLink className="button-icon" />
            Ir a mis recortes
          </button>
        </div>
      </div>
    </IconContext.Provider>
  );
}

export default ModalEditClip;
